// import { gsap } from 'gsap';
// import { IS_SP } from '../const/config';

// SPのヘッダーメニューボタン
export class Hover {
  constructor() {
    this.DOM = {};
    this.DOM.sideItems = document.querySelectorAll('[data-hover-side]');

    if (!this.DOM.sideItems) return;

    this.init();
  }

  init() {

    this.DOM.sideItems.forEach((item) => {

      // 入った時の判定
      item.addEventListener('mouseenter', (e) => {
        const rect = item.getBoundingClientRect();
        const itemCenterX = rect.left + rect.width / 2;
        const enterX = e.clientX;

        // クラスをリセット
        item.classList.remove('in-right', 'in-left', 'out-right', 'out-left');

        if (enterX > itemCenterX) {
          item.classList.add('in-right'); // 右から入った
        } else {
          item.classList.add('in-left'); // 左から入った
        }
      });

      // 出た時の判定
      item.addEventListener('mouseleave', (e) => {
        const rect = item.getBoundingClientRect();
        const itemCenterX = rect.left + rect.width / 2;
        const leaveX = e.clientX;

        // 入った時のクラスは残したままだと干渉するので消す
        item.classList.remove('in-right', 'in-left');

        if (leaveX > itemCenterX) {
          item.classList.add('out-right'); // 右に抜けた
        } else {
          item.classList.add('out-left'); // 左に抜けた
        }
      });
    });
      
    
  }

}
